/**
 * useVoiceDuration Hook
 * Calculates and updates voice session duration every second
 */

import { useState, useEffect } from 'react';

export const useVoiceDuration = (joinedAt: string): number => {
  const [duration, setDuration] = useState(
    () => Math.floor((Date.now() - new Date(joinedAt).getTime()) / 1000)
  );

  useEffect(() => {
    const startTime = new Date(joinedAt).getTime();

    // Update every second
    const interval = setInterval(() => {
      const now = Date.now();
      const elapsed = Math.floor((now - startTime) / 1000);
      setDuration(elapsed);
    }, 1000);

    return () => clearInterval(interval);
  }, [joinedAt]);

  return duration;
};

/**
 * Format duration in H:MM:SS or MM:SS format
 */
export const formatDuration = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }
  return `${minutes}:${secs.toString().padStart(2, '0')}`;
};
